module.exports = ({
    "TITLE.CREATE": "試験を新規作成",
    "TITLE.HEADER": "試験一覧",
    "BUTTON.DOWNLOAD": "ダウンロード",
    "STUDY.TEXT.STUDYID": "試験ID",
    "STUDY.TEXT.NAME": "試験名",
    "STUDY.TEXT.ROLE": "権限",
    "STUDY.TEXT.PROTOCOL": "プロトコルNo.",
});